// What the side menu and the top bar share: which entry is the current page,
// and the initials on the person's own button.
export default {
  methods: {
    // A route location as the menu holds it ('/planner' or { name, params })
    // turned into the path it opens, so both kinds compare the same way.
    linkPath (link) {
      if (!link) return null
      try {
        return typeof link === 'string' ? link : this.$router.resolve(link).path
      } catch (err) {
        // A link missing its params throws in Vue Router 4; it is simply not
        // the current page.
        return null
      }
    },
    isOn (link) {
      const path = this.linkPath(link)
      if (!path) return false
      const here = this.$route.path
      if (path === '/') return here === '/' || here.startsWith('/dashboard')
      return here === path || here.startsWith(path + '/')
    },
    groupOn (item) {
      // A child can be a group of its own (Süsteem -> Turvalisus -> Kliendid).
      return !!item.model || (item.children || []).some(child => child.children ? this.groupOn(child) : this.isOn(child.link))
    }
  }
}

export function initials (name) {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return '?'
  const first = parts[0][0]
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
  return (first + last).toUpperCase()
}

// The highest role a person holds, in the words the office uses.
export function roleLabel (roles) {
  const has = role => (roles || []).includes(role)
  if (has('root')) return 'Süsteemi haldur'
  if (has('admin')) return 'Administraator'
  if (has('secretary')) return 'Sekretär'
  if (has('tehnic')) return 'Tehnik'
  return 'Töötaja'
}
